<template>
  <div class="wrapper">
    <div class="text-container">
      <v-btn icon style="margin: 0" @click="$emit('clear')">
        <v-icon color="white"> clear </v-icon>
      </v-btn>
      <div class="pointer" />
      <div v-if="selected.length === 1">
        <span class="text">{{ selected.length }} attendee selected</span>
      </div>
      <div v-else>
        <span class="text">{{ selected.length }} attendees selected</span>
      </div>
    </div>
    <div class="button-container">
      <main-button
        v-if="showSendEmail"
        depressed
        class="desktop-button"
        text="send email"
        @click="handleSendEmailClick"
      />
      <v-btn
        icon
        style="margin: 0"
        class="hide"
        @click="goTo(routes.organizer.createEmail, { eventId: eventId, initialValues: selected })"
      >
        <v-icon color="white"> forward_to_inbox </v-icon>
      </v-btn>
      <main-button
        v-if="showPrint"
        depressed
        text="print"
        class="desktop-button"
        @click="$emit('print')"
      />
      <v-btn icon style="margin: 0" class="hide" @click="$emit('print')">
        <v-icon color="white"> print </v-icon>
      </v-btn>
      <main-button
        v-if="showAccept"
        depressed
        class="desktop-button"
        text="accept"
        @click="$emit('accept')"
      />
      <main-button depressed class="desktop-button" text="delete" @click="$emit('delete')" />
      <v-btn icon style="margin: 0" class="hide" @click="$emit('delete')">
        <v-icon color="white"> delete </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selected-attendee-header',
  props: {
    selected: Array,
    eventId: String,
    permission: String,
    showPrint: {
      default: true,
      type: Boolean,
    },
    showSendEmail: {
      default: true,
      type: Boolean,
    },
    showAccept: {
      default: false,
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    isVerifiedByCoreEvent() {
      return this.user.isVerifiedByCoreEvent
    },
  },
  methods: {
    handleSendEmailClick() {
      if (this.isVerifiedByCoreEvent) {
        this.goTo(this.routes.organizer.createEmail, { eventId: this.eventId, initialValues: this.selected })
      } else {
        this.$emit('openDemoModal')
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  color: white;
  margin: 0 0 2px 0;
  padding: 14px 10px;
  background-color: #0277bd;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 56px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text-container {
  display: flex;
  align-items: center;
}

@media (max-width: 800px) {
  .wrapper {
    height: 98px;
    flex-direction: column !important;
  }

  .text-container {
    align-self: flex-start;
    display: flex;
    justify-content: center;
  }

  .pointer {
    top: 70px !important;
  }

  .button-container {
    align-self: flex-end;
  }

  .text {
    margin-left: -16px;
  }
}

.text {
  font-family: Raleway;
  font-size: 16px;
  font-weight: bold;
}

.pointer {
  position: relative;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #0277bd;
  top: 30px;
  right: 30px;
}
</style>
